import React from "react";
import styles from './FJPreviewRetry.module.less';
import FJButton from "fj-components/FJButton";
import FJLocalStore from "../../../store/FJLocalStore";

function FJPreviewRetry(props) {

	const {retryClick, sourceId} = props;
	const handleClick = () => {retryClick(sourceId)}
	return (
		<div className={styles.retry_box}>
			<span className={styles.text}>{FJLocalStore._('preview_retry')}</span>
			<FJButton text={FJLocalStore._('retry')}
								className={styles.btn}
								onClick={handleClick}
			/>
		</div>
	)

}

export default FJPreviewRetry;